import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { generateDateTicks } from "../../services/dataTicks";

const API_BEFORE = "https://www.highcharts.com/samples/data/usdeur.json";
const API_AFTER = "https://www.highcharts.com/samples/data/usdeur.json";

const createChartOptions = (data, color, tickPositions, title) => ({
  chart: {
    type: "line",
    zooming: { type: "x" },
    spacing: [0, 0, 0, 0],
  },
  credits: {
    enabled: false,
  },
  title: {
    text: title,
    style: { fontSize: "14px", fontWeight: "bold" },
  },
  xAxis: {
    type: "datetime",
    title: { text: null },
    min: tickPositions[0],
    max: tickPositions[tickPositions.length - 1],
    tickPositions: tickPositions,
    gridLineWidth: 1,
    gridLineColor: "#eee",
    labels: {
      format: "{value:%b %d}",
      style: { fontSize: "14px", fontWeight: 600, color: "#495057" },
    },
  },
  yAxis: {
    title: { text: "Consumption (MT)" },
    gridLineColor: "#eee",
    labels: {
      step: 1,
      style: { fontSize: "14px", fontWeight: 600, color: "#495057" },
    },
    min: 0,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    line: {
      marker: { radius: 2 },
      lineWidth: 2,
      states: {
        hover: { lineWidth: 3 },
      },
      threshold: null,
    },
    series: {
      lineWidth: 2,
      marker: { enabled: true, radius: 3 },
      color: color,
    },
  },
  tooltip: {
    pointFormat:
      '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y:.2f} MT</b><br/>',
    shared: true,
  },
  series: [
    {
      type: "line",
      name: "Fuel Consumption",
      data: data,
    },
  ],
});

const APFuelUsage = (fuelUsage) => {
  console.log("fuelUsage data:", fuelUsage);

  const beforeData = fuelUsage?.fuelUsage?.beforeData?.[0] || [];
  const afterData = fuelUsage?.fuelUsage?.afterData?.[0] || [];
  const beforeDates = fuelUsage?.fuelUsage?.before_dates || [];
  const afterDates = fuelUsage?.fuelUsage?.after_dates || [];

  console.log("Additives Fuel Cons. Before data:", beforeData);
  console.log("Additives Fuel Cons. After data:", afterData);
  console.log("Additives Fuel Cons. Before dates:", beforeDates);
  console.log("Additives Fuel Cons. After dates:", afterDates);
  let beforeTickPositions = generateDateTicks(beforeDates);
  let afterTickPositions = generateDateTicks(afterDates);
  console.log("beforeTickPositions", beforeTickPositions);
  console.log("afterTickPositions", afterTickPositions);

  beforeTickPositions  = Array.from(
  new Map(
    beforeTickPositions.map(ts => [
      new Date(ts).toISOString().split("T")[0],
      ts
    ])
  ).values()
);

  afterTickPositions  = Array.from(
  new Map(
    afterTickPositions.map(ts => [
      new Date(ts).toISOString().split("T")[0],
      ts 
    ])
  ).values()
);


  const effectiveBeforeDates =
    beforeDates.length > 0 ? beforeDates : afterDates;
  const effectiveBeforeTickPositions =
    beforeTickPositions.length > 0 ? beforeTickPositions : afterTickPositions;

  return (
    <div className="p-6">
      {/* Section Headings */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-2">
        <div>
          <h2 className="text-xl text-[#1a5276]">
            Before <b>Additives</b>
          </h2>
          {beforeDates.length === 0 && (
            <p className="text-sm text-gray-500 mt-1">
              Using after dates range
            </p>
          )}
        </div>
        <div>
          <h2 className="text-xl text-[#27ae60]">
            After <b>Additives</b>
          </h2>
        </div>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Before Additives Chart */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-4">
          <HighchartsReact
            highcharts={Highcharts}
            options={createChartOptions(
              beforeData,
              "#1a5276",
              effectiveBeforeTickPositions,
              `Before Additives (${effectiveBeforeDates.length} days)`
            )}
          />
        </div>

        {/* After Additives Chart */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-4">
          <HighchartsReact
            highcharts={Highcharts}
            options={createChartOptions(
              afterData,
              "#27ae60",
              afterTickPositions,
              `After Additives (${afterDates.length} days)`
            )}
          />
        </div>
      </div>

      {/* Y-axis Label */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
        <div className="text-center my-4">
          <span className="font-bold text-[14px] text-[#495057] tracking-wide">
            Fuel Usage (tonnes)
          </span>
        </div>
        <div className="text-center my-4">
          <span className="font-bold text-[14px] text-[#495057] tracking-wide">
            Fuel Usage (tonnes)
          </span>
        </div>
      </div>
    </div>
  );
};

export default APFuelUsage;
